import { Col } from "reactstrap";
import PropTypes from "prop-types";

const LegendaCores = ({
  corLivre = "#4CAF50",
  corReservado = "#FFC107",
  corVendido = "#F44336",
  corRenovacao = "#F44336",
  corPendenteRenovacao = "#de1ad1",
  exibeRenovacao = false,
  textoLivre = "Livre",
  textoReservado = "Reservado",
  textoVendido = "Vendido",
  tamanhoQuadrado = 20,
  espacamento = 6,
  colunas = { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }
}) => {
  const estiloQuadrado = {
    width: tamanhoQuadrado,
    height: tamanhoQuadrado,
    marginRight: espacamento,
    flexShrink: 0,
  };

  const estiloItemLegenda = {
    display: "flex",
    alignItems: "center",
    marginBottom: "1px",
  };

  return (
    <Col {...colunas}>
      <div className="legendas-do-mapa">
        <div className="livre" style={estiloItemLegenda}>
          <div style={{ ...estiloQuadrado, backgroundColor: corLivre }} />
          {textoLivre}
        </div>
        <div className="alugado" style={estiloItemLegenda}>
          <div style={{ ...estiloQuadrado, backgroundColor: corReservado }} />
          {textoReservado}
        </div>
        <div className="vendido" style={estiloItemLegenda}>
          <div style={{ ...estiloQuadrado, backgroundColor: corVendido }} />
          {textoVendido}
        </div>
        {exibeRenovacao && (
          <div className="vendido" style={estiloItemLegenda}>
            <div style={{ ...estiloQuadrado, backgroundColor: corRenovacao }} />
              Renovado
          </div>
        )}
        {exibeRenovacao && (
          <div className="vendido" style={estiloItemLegenda}>
            <div style={{ ...estiloQuadrado, backgroundColor: corPendenteRenovacao }} />
              Pré-Reservado
          </div>
        )}
      </div>
    </Col>
  );
};

LegendaCores.propTypes = {
  corLivre: PropTypes.string,
  corReservado: PropTypes.string,
  corVendido: PropTypes.string,
  corRenovacao: PropTypes.string,
  exibeRenovacao: PropTypes.bool,
  textoLivre: PropTypes.string,
  textoReservado: PropTypes.string,
  textoVendido: PropTypes.string,
  tamanhoQuadrado: PropTypes.number,
  espacamento: PropTypes.number,
  colunas: PropTypes.object,
};

export default LegendaCores;